export default function(x) {
  return +x;
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-scale/src/number.js
// module id = ../../../../d3-scale/src/number.js
// module chunks = 4